/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalRegister = {
  properties: {
    status: {
      type: 'string',
      isRequired: true,
    },
    register: {
      type: 'string',
    },
    additionalData: {
      properties: {
      },
    },
  },
} as const;
